import { BookingSite } from 'core/bookingLinks/types';

// "Site type: Site name (store code)", dropping whichever parts the site lacks.
// The store code is part of the label so the dropdown search matches on it too.
const siteOptionLabel = (site: BookingSite): string => {
    const name = site.storeCode ? `${site.name} (${site.storeCode})` : site.name;
    return site.siteType ? `${site.siteType}: ${name}` : name;
};

export default siteOptionLabel;
